export const sortSubject = (subjects) => {
  if (!subjects) return [];
  if (subjects.length === 0) return [];
  if (subjects.length === 1) return subjects;
  return [...subjects].sort((a, b) =>
    a.serial < b.serial
      ? -1
      : a.serial > b.serial
      ? 1
      : `${a.name}`.charAt(0) < `${b.name}`.charAt(0)
      ? -1
      : `${a.name}`.charAt(0) > `${b.name}`.charAt(0)
      ? 1
      : 0
  );
};
